/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMinus = createReactComponent("outline", "minus", "IconMinus", [["path", { "d": "M5 12l14 0", "key": "svg-0" }]]);

export { IconMinus as default };
//# sourceMappingURL=IconMinus.mjs.map
